import { QUERY_KEY_MY_MONITORING_GET_SITE_EVENTS_INFINITE } from '@apps-common/apis/my-monitoring/site'
import { queryClient } from '@apps-common/lib'

export const invalidateSiteEventQueries = (unitId?: string) => {
  const rootKey = QUERY_KEY_MY_MONITORING_GET_SITE_EVENTS_INFINITE()[0]

  queryClient.invalidateQueries({
    predicate: (query) => {
      const queryKey = query.queryKey

      if (queryKey[0] !== rootKey) {
        return false
      }

      return !unitId || queryKey.includes(unitId)
    }
  })
}
